import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {
  Alert,
  Button,
  Col,
  Form,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row
} from "reactstrap";
import LaddaButton, {ZOOM_OUT} from "react-ladda";
import api from "../../../api";

const CintRequirePostalCodeModal = props => {
  const [modalOpen, setModalOpen] = React.useState(!props.surveyResponse.user.postalCode);
  const toggleModalOpen = () => setModalOpen(!modalOpen);
  const [postalCode, setPostalCode] = React.useState('');
  const [errors, setErrors] = React.useState(false);
  const [saving, setSaving] = React.useState(false);

  const onSubmit = (e) => {
    e.preventDefault();

    save();
  }

  const save = () => {
    setSaving(true);
    setErrors(false);

    api.user.updatePostalCode({
      postalCode,
    }).then(data => {
      setSaving(false);
      window.location.reload();
    }).catch(res => {
      setErrors(true);
      setSaving(false);
    })
  }


  if(!modalOpen){
    return null;
  }
  return (
    <Modal isOpen={modalOpen} size="md">
      <ModalHeader tag="h4">Uzupełnij kod pocztowy</ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        <Form onSubmit={onSubmit} className="needs-validation">
          <Alert color="info">Aby wypełnić tę ankietę proszę podaj swój kod pocztowy</Alert>
          <Row className="mb-3">
            <Col md={4}>
              <Label data-role="label" for="postalCode" className="mb-0 mt-2">Kod pocztowy</Label>
            </Col>
            <Col md={8}>
              <Input type="text" autoFocus id="postalCode" name="postalCode" placeholder='01-234' value={postalCode} invalid={!!errors} onChange={e => setPostalCode(e.target.value)}/>
              {errors && <div className="invalid-feedback">Kod pocztowy jest niepoprawny</div>}
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <LaddaButton
          className="btn btn-primary btn-ladda"
          loading={saving}
          data-style={ZOOM_OUT}
          onClick={save}
        >Zapisz w profilu</LaddaButton>
      </ModalFooter>
    </Modal>
  );
};

CintRequirePostalCodeModal.propTypes = {
  surveyResponse: PropTypes.shape({
    survey: PropTypes.shape({
      cintProjectId: PropTypes.number,
    }).isRequired,
    user: PropTypes.shape({
      postalCode: PropTypes.string,
    }),
  }).isRequired
};

function mapStateToProps(state) {
  return {
    surveyResponse: state.surveyResponse,
  }
}

export default connect(mapStateToProps)(CintRequirePostalCodeModal);